import React from "react";
import { Icon, Table, Alert } from "antd";
import LoadingIndicator from "../shared/LoadingIndicator/LoadingIndicator";

function DashboardSettingsKeywordsTable(props) {
  function getTableDataSource(keywords) {
    return keywords
      .sort((a, b) => (a.c_at < b.c_at ? -1 : a.c_at > b.c_at ? 1 : 0))
      .map((keyword, idx) => ({
        key: idx + 1,
        keyword: keyword["phrase"]
      }));
  }

  const columns = [
    {
      dataIndex: "key",
      width: "54px"
    },
    {
      dataIndex: "keyword",
      key: "keyword",
      className: "keywords"
    },
    {
      dataIndex: "deleteKeyword",
      key: "deleteKeyword",
      align: "right",
      render: (_, record) => (
        <span
          className={`remove-item ${props.keywordsBeingDeleted.includes(record.keyword) ? "in-progress" : ""}`}
          onClick={() => props.handleDelete(record.keyword)}>
          {props.keywordsBeingDeleted.includes(record.keyword) ? <Icon type="loading" /> : <Icon type="delete" />}
        </span>
      )
    }
  ];

  if (props.isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="dashboard-settings-tracked-keywords-table">
      {props.keywords.length ? (
        <Table
          columns={columns}
          dataSource={getTableDataSource(props.keywords)}
          showHeader={false}
          pagination={false}
        />
      ) : (
        <Alert message="You haven't set any keywords to track for this domain!" />
      )}
    </div>
  );
}

export default DashboardSettingsKeywordsTable;
